import { useContext } from 'react';
import MojitoPresentation from 'mojito/presentation';
import { EventListContext } from '../context/event-list-context.js';

const { ImageButton } = MojitoPresentation.Components;
const { NavigationPathBuilder } = MojitoPresentation.Base.Navigation;
const { IntentActionTrigger } = MojitoPresentation.Base.Intent;

const resolveAllEventsLabel = (sportName, isInPlay, eventCount, stringResolver) => {
    const l10nKey = isInPlay
        ? `$EVENT_LIST.ALL_INPLAY_EVENTS_BUTTON`
        : `$EVENT_LIST.ALL_EVENTS_BUTTON`;
    return stringResolver.resolveAndFormatString(l10nKey, sportName, eventCount);
};

const NavigationBarButton = props => {
    const {
        eventGroupsId,
        sportId,
        sportName,
        redirectToTypePage,
        label: navigationButtonLabel,
        renderedEventCount,
        typeId,
        showAllEventsButton,
        isCouponNavigation,
        allowTypePageRedirect,
        isInPlay,
        onShowAllButtonClick,
        mojitoTools: { config, stringResolver, appContext },
    } = props;
    const { routeResolver } = appContext;
    const redirectsToTypePage = Boolean(redirectToTypePage && typeId && allowTypePageRedirect);
    const { numberOfEvents } = useContext(EventListContext) || {};

    const getShowAllEventsHref = () => {
        if (isCouponNavigation) {
            return redirectsToTypePage
                ? NavigationPathBuilder.sportCompetitionsPath(sportId, typeId, routeResolver)
                : NavigationPathBuilder.sportCouponPath(sportId, eventGroupsId, routeResolver);
        }

        return isInPlay
            ? NavigationPathBuilder.inplayPath(sportId, routeResolver)
            : NavigationPathBuilder.sportPath(sportId, routeResolver);
    };

    const onShowAllEventsClick = () => {
        if (isCouponNavigation) {
            if (redirectsToTypePage) {
                IntentActionTrigger.showSportCompetitions(sportId, typeId);
            } else {
                IntentActionTrigger.showSportCouponPage(sportId, eventGroupsId);
            }
            return;
        }

        if (isInPlay) {
            IntentActionTrigger.showInPlay(sportId);
        } else {
            IntentActionTrigger.showSport(sportId);
        }
        onShowAllButtonClick(sportId);
    };

    if (!showAllEventsButton) {
        return null;
    }

    const label =
        navigationButtonLabel ??
        resolveAllEventsLabel(
            sportName,
            isInPlay,
            numberOfEvents || renderedEventCount,
            stringResolver
        );

    return (
        <ImageButton
            onClick={onShowAllEventsClick}
            hrefLink={getShowAllEventsHref()}
            label={label}
            config={config.button}
        />
    );
};

export default NavigationBarButton;
